import { useResetAtom } from 'jotai/utils';

import {
  alertBannerAtom,
  billingDetailsAtom,
  bookingWindowIdAtom,
  customerDetailsAtom,
  customerDetailsConfirmedAtom,
  damageTypePageConfirmedAtom,
  deliveryMethodAtom,
  deliverySelectionConfirmedAtom,
  deviceColorOptionIdsAtom,
  deviceDetailsAtom,
  deviceDetailsPageConfirmedAtomWithStorage,
  deviceTypeAtom,
  deviceTypePageConfirmedAtomWithStorage,
  fullAddressAtom,
  geolocationAtom,
  leadIdAtom,
  mailInAtom,
  postalCodeAtom,
  remoteTechAtom,
  repairMessageAtom,
  selectedRepairIdsAtom,
  selectedRepairTypeIdsAtom,
  storeIdAtom,
  updatedLeadIdAtom,
  useResetCompanyIdAtom,
  useResetSelectedAppointment,
} from '../atoms';

export const useResetApplicationState = () => {
  const resetSelectedAppointment = useResetSelectedAppointment();
  const resetSelectedRepairTypeIds = useResetAtom(selectedRepairTypeIdsAtom);
  const resetSelectedRepairIds = useResetAtom(selectedRepairIdsAtom);
  const resetRepairMessage = useResetAtom(repairMessageAtom);
  const resetCompanyId = useResetCompanyIdAtom();
  const resetDamageTypePageConfirmed = useResetAtom(
    damageTypePageConfirmedAtom
  );
  const resetDeviceDetailsPageConfirmed = useResetAtom(
    deviceDetailsPageConfirmedAtomWithStorage
  );
  const resetDeviceTypePageConfirmed = useResetAtom(
    deviceTypePageConfirmedAtomWithStorage
  );

  const resetDeviceType = useResetAtom(deviceTypeAtom);
  const resetDeviceDetails = useResetAtom(deviceDetailsAtom);
  const resetDeviceColorOptionIdsState = useResetAtom(deviceColorOptionIdsAtom);

  const resetBookingWindowId = useResetAtom(bookingWindowIdAtom);
  const resetPostalCode = useResetAtom(postalCodeAtom);
  const resetGeolocation = useResetAtom(geolocationAtom);
  const resetFullAddress = useResetAtom(fullAddressAtom);
  const resetDeliverySelectionConfirmed = useResetAtom(
    deliverySelectionConfirmedAtom
  );
  const resetStoreId = useResetAtom(storeIdAtom);
  const resetCustomerDetails = useResetAtom(customerDetailsAtom);
  const resetCustomerDetailsConfirmed = useResetAtom(
    customerDetailsConfirmedAtom
  );
  const resetDeliveryMethod = useResetAtom(deliveryMethodAtom);
  const resetMailIn = useResetAtom(mailInAtom);
  const resetRemoteTech = useResetAtom(remoteTechAtom);
  const alertBannerState = useResetAtom(alertBannerAtom);
  const resetBillingDetails = useResetAtom(billingDetailsAtom);
  const resetLeadId = useResetAtom(leadIdAtom);
  const resetUpdatedLeadId = useResetAtom(updatedLeadIdAtom);

  return () => {
    resetBookingWindowId();
    resetSelectedAppointment();
    resetSelectedRepairTypeIds();
    resetSelectedRepairIds();
    resetRepairMessage();
    resetCompanyId();
    resetDamageTypePageConfirmed();
    resetDeviceDetailsPageConfirmed();
    resetDeviceTypePageConfirmed();
    resetDeliverySelectionConfirmed();
    resetPostalCode();
    resetGeolocation();
    resetFullAddress();
    resetDeviceType();
    resetDeviceDetails();
    resetStoreId();
    resetCustomerDetails();
    resetCustomerDetailsConfirmed();
    resetDeliveryMethod();
    resetMailIn();
    resetRemoteTech();
    resetDeviceColorOptionIdsState();
    alertBannerState();
    resetBillingDetails();
    resetLeadId();
    resetUpdatedLeadId();
  };
};
